export default __webpack_public_path__ + "static/Freight-SansBold-a29877998d7d356e345759bbc7513f4c.woff";